import React, { Component } from 'react';

export class ChartTypeToggle extends Component {

    render() {
        return <div className={"charttypetoggle" + (this.props.checked ? " checked" : "")} onClick={this.props.onType}><div className="knob" /></div>;
    }
}
